module.exports = __webpack_public_path__ + "static/media/33opinto.ee51360d.mp3";